import Icon from "../../Icon/Icon";
import {useLayoutEffect, useRef, useState} from "react";
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import SkillCard from "./SkillCard";

gsap.registerPlugin(ScrollTrigger);

export default function SkillsCards({developmentSkills}) {
  const [more, setMore] = useState(false)
  const devSkillsRef = useRef(null)
  // let tl = gsap.timeline({defaults: {ease: "power4.inOut", duration: 1}})
  useLayoutEffect(() => {
    let mm = gsap.matchMedia(devSkillsRef),
        breakPoint = 500;

    mm.add({
      // set up any number of arbitrarily-named conditions. The function below will be called when ANY of them match.
      isDesktop: `(min-width: ${breakPoint}px) and (prefers-reduced-motion: no-preference)`,
      isMobile: `(max-width: ${breakPoint - 1}px) and (prefers-reduced-motion: no-preference)`
    }, (context) => {
      // context.conditions has a boolean property for each condition defined above indicating if it's matched or not.
      // let {isDesktop, isMobile} = context.conditions
      // target = isDesktop ? ".desktop" : ".mobile",
      // if (isMobile) return
      let card = gsap.to('.skillCard', {
        scrollTrigger: {
          trigger: devSkillsRef.current,
          start: "center bottom",
          toggleActions: "play none none none",
        },
        opacity: 1,
        y: 0,
        immediateRender: false,
        ease: "power2.out",
        duration: 0.6,
        stagger: more ? 0 : 0.1
      });
      return () => {
        card.kill()
        // optionally return a cleanup function that will be called when the media query no longer matches
      }
    });


  }, [devSkillsRef, more])
  return (
      <ul ref={devSkillsRef} className={'skillUl flex gap-1 md:gap-4 flex-wrap text-center justify-center md:justify-start mt-4'}>
        {developmentSkills.slice(0, more ? 30 : 9).map(({name, icon, color}, i) => (
            // <li key={i} className='drop-shadow-xl shadow-bg-nfr-color-900 bg-nfr-color-200 dark:bg-nfr-color-800'>
            <SkillCard key={i} name={name} cssClass='shouldAnimateUp'/>
        ))}
        {developmentSkills.length > 10 &&
            <li
                className='hoverLink cursor-pointer skillCard border border-sky-500 bg-gray-400 dark:bg-gray-600 opacity-0 transform translate-y-6'
                onClick={() => setMore(!more)}>
              <div className={`skillIcon pa-2 delay-200`}>
                <Icon name={more ? 'Less' : 'More'} color='text-gray-800 dark:text-gray-400'></Icon>
              </div>
              <strong><small>{more ? 'See Less' : 'See More'}</small></strong>
            </li>
        }
      </ul>
  )
}
